import { UI, HStack, VStack } from '@genial/components';
import { BoxRadius } from '@genial/design-tokens';
import React from 'react';

export interface AssetTitleWithImageProps {
  image: string;
  title: string;
  subtitle?: string;
}

export const AssetTitleWithImage: React.FC<AssetTitleWithImageProps> = ({
  image,
  title,
  subtitle,
}) => {
  return (
    <HStack alignItems="center" space="inline.xxxs">
      <UI.ImageFallback
        src={image}
        alt={`${title}-logo`}
        width="54px"
        height="48px"
        testID="product-img"
        resizeMode="cover"
        borderRadius={BoxRadius.sm}
        resizeMethod="scale"
      />
      <UI.Tooltip label={title || ''}>
        <VStack>
          <UI.Text variant="semibold" color="neutral.darkest" noOfLines={1}>
            {title}
          </UI.Text>

          {!!subtitle && (
            <UI.Text variant="regular" color="neutral.darkest">
              {subtitle}
            </UI.Text>
          )}
        </VStack>
      </UI.Tooltip>
    </HStack>
  );
};
